import $ from "jquery";

class GoogleMaps {
    constructor($map) {
        this.$map = $map;
        this.Options = {
            zoom: 15,
            mapType: google.maps.MapTypeId.HYBRID,
            navigation: google.maps.NavigationControlStyle.DEFAULT
        };

        google.maps.event.addDomListener(window, 'load', function() {
            this.initialize();
        }.bind(this));
    }

    initialize() {
        let infoText = decodeURIComponent(this.$map.data('markerDescription')).replace(/\+/g, ' '),
            rowsInfoText = infoText.split("<br>"),
            latitude = this.$map.data('latitude'),
            longitude = this.$map.data('longitude'),
            latlng = new google.maps.LatLng(latitude, longitude),
            mapOptions = {
                center: latlng, zoom: this.Options.zoom, mapTypeId: this.Options.mapType,
                navigationControlOptions: {
                    style: this.Options.mapType
                }
            }, mapCenter = {
                position: latlng, title: rowsInfoText[0]
            },
            googleMap = new google.maps.Map(this.$map[0], mapOptions),
            marker = new google.maps.Marker(mapCenter);

        if ('' != infoText){
            infoText = infoText.replace(/\n/g, "<br>");
            var infoBox = {};
            infoBox.content = infoText;

            var infowindow = new google.maps.InfoWindow(infoBox);
            // add listener
            google.maps.event.addListener(marker, 'click', function(){
                infowindow.open(googleMap,marker);
            });
            infowindow.open(googleMap,marker);
        }

        marker.setMap(googleMap);
    }
}

export default GoogleMaps;